module.exports = __webpack_public_path__ + "img/icon_sie_assistance.99aded31.svg";